import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-create-history-group',
  templateUrl: './create-history-group.component.html',
  styleUrls: ['./create-history-group.component.scss']
})
export class CreateHistoryGroupComponent implements OnInit {

  name: string = "Untitled group";

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
  }

}


// WEBPACK FOOTER //
// ./src/app/history/create-history-group.component.ts